import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAcneBodySprayGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M23.51 16.32h.57c.72 0 1.31-.59 1.31-1.31v-.52c0-.72-.59-1.31-1.31-1.31h-.57v-.58c0-1.16-1.61-1.69-3.11-1.69-1.5 0-3.11.53-3.11 1.69l.04 3.6c-1.35.43-2.33 1.17-2.33 2.22l.09 18.96c.08 1.36 2.34 2.38 5.25 2.38s5.17-1.02 5.25-2.38v-.02l.08-18.94c0-.95-.96-1.66-2.16-2.1Zm0-1.86h.64v.61h-.64v-.61Zm-3.1-2.3c1.01 0 1.64.28 1.82.44-.19.16-.82.44-1.82.44s-1.64-.28-1.83-.44c.19-.16.82-.44 1.83-.44Zm1.81 5.02v.04c-.17.16-.84.43-1.82.43-.98 0-1.64-.27-1.82-.43v-3.23c.54.2 1.19.3 1.82.3.63 0 1.28-.1 1.82-.3v3.19Zm2.14 19.71-.03.42c-.02.28-1.3 1.2-4 1.2s-3.98-.92-4-1.23l-.02-.29V20.22c1.03.56 2.53.85 4.03.85 1.47 0 2.99-.3 4.03-.87v16.69h-.01Zm-4.03-17.07c-2.45 0-4.08-.84-4.08-1.39 0-.28.41-.62 1.12-.9.01.02.01.05.02.07.23.85 1.62 1.3 3.01 1.3 1.39 0 2.79-.45 3.02-1.31v-.01c.62.27.99.58.99.84.01.56-1.62 1.4-4.08 1.4ZM28.68 17.96l-.45.43 1.93 2.03.45-.43.46-.43-1.94-2.03-.45.43ZM28.97 11.84 31 9.91 30.14 9l-2.03 1.93.43.46.43.45ZM29.527 14.02l-.031 1.25 4.468.111.032-1.25-4.47-.111Z",
    fill: "currentColor"
  }));
}

export { SvgAcneBodySprayGlyph as default };
